const STORAGE_KEY = 'car-pool.webapp.user';
const MAX_AGE_MS = 23 * 60 * 60 * 1000;

function getStorage() {
  try {
    if (typeof window === 'undefined') return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

export function loadStoredUser() {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.user?.token) return null;

    if (typeof parsed.savedAt === 'number' && Date.now() - parsed.savedAt > MAX_AGE_MS) {
      storage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsed.user;
  } catch {
    return null;
  }
}

export function saveStoredUser(user) {
  const storage = getStorage();
  if (!storage || !user?.token) return;

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify({ user, savedAt: Date.now() }));
  } catch {
    // ignore quota / unavailable storage errors
  }
}

export function clearStoredUser() {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
